import api from "services/api";
import { routers_constants } from "services/constants";

interface IProfileEntryData {
  customerId: number;
}

export const profileServices = {
  getUserCustomerProfileByPlace: async ({ customerId }: IProfileEntryData) => {
    try {
      const uri =
        routers_constants.profile.getUserCustomerProfileByPlace(customerId);
      const { data } = await api.get(uri);
      return {
        data: data.data,
        success: true,
      };
    } catch (error: any) {
      return {
        data: error?.response?.data,
        success: false,
      };
    }
  },
};
